module.exports = __webpack_public_path__ + "img/icon-product-info-list.b272118.png";